import { useEffect } from 'react';
import { usePortfolio } from '../context/PortfolioContext';
import { 
  PnLChart, 
  AllocationChart, 
  PositionPnLChart, 
  CashHistoryChart,
  SectorAllocationChart,
  CurrencyDistributionChart
} from '../components/charts';
import SummaryCards from '../components/SummaryCards';

function DashboardPage() {
  const { summary, refreshAll, isLoading } = usePortfolio();

  useEffect(() => {
    // Only refresh if no data exists to prevent chart reloads on navigation
    if (!summary) {
      refreshAll();
    }
  }, [refreshAll, summary]);

  if (isLoading && !summary) {
    return (
      <div className="loading-screen" style={{ minHeight: '400px' }}>
        <div className="loading-spinner"></div>
        <p>Loading dashboard...</p>
      </div>
    );
  }

  return (
    <div>
      {/* Summary Cards */}
      <SummaryCards />

      {/* P&L Chart */}
      <div style={{ marginBottom: '1rem' }}>
        <PnLChart />
      </div>

      {/* Charts Row */}
      <div className="dashboard-grid dashboard-grid-2">
        <PositionPnLChart />
        <AllocationChart />
      </div>
      
      {/* Sector and Currency Distribution Row */}
      <div className="dashboard-grid dashboard-grid-2" style={{ marginTop: '1rem' }}>
        <SectorAllocationChart />
        <CurrencyDistributionChart />
      </div>
      
      {/* Cash History Chart */}
      <div style={{ marginTop: '1rem' }}>
        <CashHistoryChart />
      </div>
    </div>
  );
}

export default DashboardPage;
